export const getDisclaimerKey = (enableAIDisclaimer, spamProtectionEnabled) => {
  if (enableAIDisclaimer && spamProtectionEnabled) {
    return 'conversations-visitor-experience-components.aiDisclaimerWithSpamProtection';
  } else if (enableAIDisclaimer) {
    return 'conversations-visitor-experience-components.aiDisclaimer';
  } else if (spamProtectionEnabled) {
    return 'conversations-visitor-experience-components.spamProtectionEnabled';
  }
  return undefined;
};